import { clientConfigSchema, type ClientConfig } from './schema.js';

export function parseClientConfig(raw: unknown): ClientConfig {
  const result = clientConfigSchema.safeParse(raw);
  if (!result.success) {
    throw new Error(
      `Invalid client config: ${result.error.issues
        .map((i) => `${i.path.join('.')}: ${i.message}`)
        .join('; ')}`,
    );
  }
  return result.data;
}
